import { ROUTES } from "../../config/routes";

export const MAPPING_DETAILS: Record<string, { title: string, url: string }> = {
  dc: { title: "Datacenters", url: ROUTES["datacenter"].url },
  rack: { title: "Racks", url: ROUTES["rack"].url },
  bench: { title: "Benches", url: `${ROUTES["rack"].url}?page=1&pageSize=50&sortColumn=id&orderBy=desc&managerType=Bench` },
  rm: { title: "RMs", url: ROUTES["rackManager"].url },
  sarm: { title: "SARMs", url: `${ROUTES["rack"].url}?page=1&pageSize=50&sortColumn=id&orderBy=desc&rackModel=StandAlone` },
  cm: { title: "CMs", url: ROUTES["chassisManager"].url },
  baas: { title: "BAAS", url: `${ROUTES["baasRaasLeaseManagement"].url}?page=1&pageSize=50&sortColumn=id&orderBy=desc&rackModel=BAAS` },
  raas: { title: "RAAS", url: `${ROUTES["baasRaasLeaseManagement"].url}?page=1&pageSize=50&sortColumn=id&orderBy=desc&rackModel=RAAS` },
  blades: { title: "Blades", url: ROUTES["blade"].url },
  jBods: { title: "JBODs", url: `${ROUTES["jbod"].url}?page=1&pageSize=50&sortColumn=id&orderBy=desc&modeltype=JBOD` },
  jBofs: { title: "JBOFs", url: `${ROUTES["jbod"].url}?page=1&pageSize=50&sortColumn=id&orderBy=desc&modeltype=JBOF` },
  disks: { title: "Disks", url: ROUTES["disks"].url },
  dimms: { title: "DIMMs", url: ROUTES["dimms"].url },
  procs: { title: "PROCs", url: ROUTES["procs"].url },
  nics: { title: "NICs", url: ROUTES["nics"].url },
  infraDevice: { title: "Infra Devices", url: ROUTES["infraDevice"].url },
  skUs: { title: "SKUs", url: ROUTES["sustaining"].url },
  fpgAs: { title: "FPGAs", url: ROUTES["fpgas"].url },
  imt: { title: "IMT", url: `${ROUTES["labInventory"].url}?page=1&pageSize=50&sortColumn=id&orderBy=desc&sourceToolId=2` },
  schieLab: { title: "SCHIE Lab", url: `${ROUTES["labInventory"].url}?page=1&pageSize=50&sortColumn=id&orderBy=desc&sourceToolId=4` },
  isAndT: { title: "IS&T", url: `${ROUTES["labInventory"].url}?page=1&pageSize=50&sortColumn=id&orderBy=desc&sourceToolId=3` },
  slam: { title: "SLAM", url: `${ROUTES["labInventory"].url}?page=1&pageSize=50&sortColumn=id&orderBy=desc&sourceToolId=6` },
  ims: { title: "IMS", url: `${ROUTES["labInventory"].url}?page=1&pageSize=50&sortColumn=id&orderBy=desc&sourceToolId=5` },
  taiwan: { title: "Taiwan", url: `${ROUTES["labInventory"].url}?page=1&pageSize=50&sortColumn=id&orderBy=desc&sourceToolId=1` },
};
